<template>
	<el-date-picker size="small" :class="!(dataResult && dataResult.length)?'nullValue':''" v-if="daterange" v-model="dataResult" value-format="yyyy-MM-dd" type="daterange" range-separator="~" :start-placeholder="placeholder" end-placeholder="结束时间" style="width:100%" :disabled="disabled" />
	<el-date-picker size="small" @change="change" v-else v-model="dataResult" value-format="yyyy-MM-dd" type="date" :placeholder="placeholder" :disabled="disabled" :picker-options="picker ? picker : (pickerLimit ? pickerAfterToday: {})" />
</template>

<script>
	import Vue, { Component } from 'C/BaseVue'
	import { pickerAfterToday } from 'service/utils'

	@Component({
		props: ['placeholder', 'daterange', 'result', 'disabled', 'pickerLimit','picker'],
		watch: {
			dataResult : {
				handler(curVal, oldVal){
					this.$emit('update:result', curVal)
				}
			},
			result : {
				handler(curVal, oldVal){
					this.dataResult = curVal
				}
			}
		},
	})

	export default class DatePickerTabs extends Vue {
		dataResult = ''
		mounted(){
			this.dataResult = this.result
		}
		get pickerAfterToday(){
            return pickerAfterToday()
		}
		
		change(val){
			this.$emit('changeCallback',val)
		}
	}

</script>

<style lang="scss" type="text/css">
	.nullValue{
		.el-range-input:nth-child(2){
			width: 86%;
			text-align: left;
		}
		.el-range-input:nth-child(4),.el-range-separator{
			display:none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/DatePickerTabs.vue